export default {"src":"/_next/static/media/403.845e9a3e.svg","height":656,"width":1200,"blurWidth":0,"blurHeight":0};